
      var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEditSubscriberIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 81,
  height: 80,
  viewBox: "0 0 81 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.97 64.83a1 1 0 0 0 1.727 1.009l-1.727-1.01zm53.333 1.01a1 1 0 1 0 1.727-1.01l-1.727 1.01zM57.53 40.12a1 1 0 0 0-1.828-.813l1.828.813zM42.799 16.49a1 1 0 0 0 .272-1.981l-.272 1.981zM14.697 65.839c5.321-9.106 15.155-14.72 25.803-14.72v-2c-11.351 0-21.846 5.985-27.53 15.71l1.727 1.01zM40.5 51.119c10.648 0 20.482 5.614 25.803 14.72l1.727-1.009c-5.684-9.726-16.179-15.71-27.53-15.71v2zm15.201-11.812c-3.444 7.748-12.3 11.638-20.437 8.954l-.627 1.9c9.1 3.001 19.025-1.342 22.892-10.041l-1.828-.813zm-20.437 8.954C27.13 45.578 22.417 37.22 24.367 28.987l-1.946-.461c-2.193 9.258 3.112 18.632 12.216 21.634l.627-1.899zM24.367 28.987c1.95-8.237 9.934-13.663 18.432-12.496l.272-1.981c-9.501-1.305-18.458 4.76-20.65 14.016l1.946.46z",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M53.026 31.918h-4.773a.796.796 0 0 1-.796-.795v-4.444c0-.211.084-.414.233-.563l11.934-11.933a.796.796 0 0 1 1.125 0l4.444 4.444c.31.31.31.814 0 1.125L53.026 31.918z",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m56.462 17.344 5.57 5.569",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

      const __svgRaw = "<svg width=\"81\" height=\"80\" viewBox=\"0 0 81 80\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path d=\"M12.97 64.83a1 1 0 0 0 1.727 1.009l-1.727-1.01zm53.333 1.01a1 1 0 1 0 1.727-1.01l-1.727 1.01zM57.53 40.12a1 1 0 0 0-1.828-.813l1.828.813zM42.799 16.49a1 1 0 0 0 .272-1.981l-.272 1.981zM14.697 65.839c5.321-9.106 15.155-14.72 25.803-14.72v-2c-11.351 0-21.846 5.985-27.53 15.71l1.727 1.01zM40.5 51.119c10.648 0 20.482 5.614 25.803 14.72l1.727-1.009C62.346 55.104 51.851 49.12 40.5 49.12v2zm15.201-11.812c-3.444 7.748-12.3 11.638-20.437 8.954l-.627 1.9c9.1 3.001 19.025-1.342 22.892-10.041l-1.828-.813zm-20.437 8.954C27.13 45.578 22.417 37.22 24.367 28.987l-1.946-.461c-2.193 9.258 3.112 18.632 12.216 21.634l.627-1.899zM24.367 28.987c1.95-8.237 9.934-13.663 18.432-12.496l.272-1.981c-9.501-1.305-18.458 4.76-20.65 14.016l1.946.46z\" fill=\"#000000\"/>\r\n    <path clip-rule=\"evenodd\" d=\"M53.026 31.918h-4.773a.796.796 0 0 1-.796-.795v-4.444c0-.211.084-.414.233-.563l11.934-11.933a.796.796 0 0 1 1.125 0l4.444 4.444c.31.31.31.814 0 1.125L53.026 31.918z\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n    <path d=\"m56.462 17.344 5.57 5.569\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/editSubscriberIcon.9954417da7fb8ea389b067bd04947bd7.svg"),
        {
          React: SvgEditSubscriberIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      